import { BrowserRouter, Link, Navigate, Route, Routes } from 'react-router-dom';
import { Workspace } from '@/features/proposition/components/shell/Workspace';
import AuthPlaceholder from './features/auth/components/Placeholder';
import BillingPlaceholder from './features/billing/components/Placeholder';
import LlmsPlaceholder from './features/llms/components/Placeholder';

// The Portfolio Executive companion app. The proposition workspace is the
// primary surface; the auth/billing/llms placeholder routes remain for
// future feature work and have their own minimal nav inline.

function PlaceholderShell({ title, children }) {
  return (
    <div style={{ padding: 24, maxWidth: 980, margin: '0 auto', fontFamily: 'system-ui' }}>
      <header>
        <h1>{title}</h1>
        <nav style={{ display: 'flex', gap: 12, marginTop: 12 }}>
          <Link to="/proposition">← Workspace</Link>
          <Link to="/auth">Auth</Link>
          <Link to="/billing">Billing</Link>
          <Link to="/llms">LLMs</Link>
        </nav>
      </header>
      <main style={{ marginTop: 20 }}>{children}</main>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/proposition" replace />} />
        <Route path="/proposition/*" element={<Workspace />} />
        <Route
          path="/auth"
          element={<PlaceholderShell title="Auth (placeholder feature)"><AuthPlaceholder /></PlaceholderShell>}
        />
        <Route
          path="/billing"
          element={<PlaceholderShell title="Billing (placeholder feature)"><BillingPlaceholder /></PlaceholderShell>}
        />
        <Route
          path="/llms"
          element={<PlaceholderShell title="LLMs (placeholder feature)"><LlmsPlaceholder /></PlaceholderShell>}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
